import templateUrl from './user.password.html'

/**
 * Change User Password route
 *
 * @namespace routes.AdminUserPassword
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.users.password',
  label: 'ADMIN.USERS.PASSWORD.TITLE',
  url: '/password',
  component: 'tmrAdminUserPassword',
  accessControl: [],
  resolve: {
    passwordOptions: /*@ngInject*/ TmrApi =>
      TmrApi.get('passwordOptions').then(({ data }) => {
        for (const key in data) {
          if (data[key] === 'true') data[key] = true
          else if (data[key] === 'false') data[key] = false
        }
        return data
      }),
    passwordConstraints: /*@ngInject*/ ($translate, passwordOptions) => {
      let passwordConstraints = []
      if (passwordOptions['tmr.password.enforcer.requires.digit'])
        passwordConstraints.push('ADMIN.USERS.PASSWORD.DIGIT')
      if (passwordOptions['tmr.password.enforcer.requires.uppercase'])
        passwordConstraints.push('ADMIN.USERS.PASSWORD.UPPERCASE')
      if (passwordOptions['tmr.password.enforcer.requires.symbol'])
        passwordConstraints.push('ADMIN.USERS.PASSWORD.SYMBOL')
      return $translate(passwordConstraints).then(translated =>
        Object.values(translated).join(', ')
      )
    },
  },
}

/**
 * Component for {@link routes.tmrAdminUserPassword Change User Password route}
 *
 * @type {ngComponent}
 */
export const tmrAdminUserPassword = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminUserPasswordController',
  bindings: {
    loggedUser: '<',
    resource: '<',
    successMessage: '<',
    passwordOptions: '<',
    passwordConstraints: '<',
  },
}

/**
 * Controller of component {@link tmrAdminUserPassword}.
 *
 * @type {ngController}
 */
export class tmrAdminUserPasswordController {
  static ngType = 'controller'

  constructor($state, TmrApiAuth, TmrToast, $translate) {
    'ngInject'
    Object.assign(this, { $state, TmrApiAuth, TmrToast, $translate })
  }

  $onInit() {
    this.askPassword = this.loggedUser.loginType != 'TEMPORARY'
  }

  onSubmit() {
    this.TmrApiAuth.changePassword({
      oldPassword: this.oldPassword,
      newPassword: this.password,
    }).then(
      () => this.submitSuccess(),
      err => this.submitError(err)
    )
  }

  submitSuccess() {
    this.TmrToast.success('ADMIN.USERS.PASSWORD.SUCCESS')
    return this.$state.go('app')
  }

  submitError(err) {
    return this.TmrToast.exception(err)
  }
}
